import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const FAQ = () => {
  const faqs = [{
    question: 'How Can I Contact Customer Support?',
    answer: 'You can reach us by email at 23tata0716@gmail.com or phone at 0800 055 4969. Our support team is available Monday to Friday from 9 am to 5 pm. Messages received outside these hours will be responded to on the next working day.'
  }, {
    question: 'When Does My Service Plan Start and End?',
    answer: 'Your Opticore coverage begins as soon as your payment is confirmed. For example, if you purchase a 12-month plan on 15 July, your protection lasts until 23:59 on 14 July the following year. Activation is immediate after payment clears, and a confirmation email will be sent straight away. No further action is needed on your part. Coverage lasts for 12 months from the purchase date and ends exactly 12 months later at 23:59, unless you choose to renew for continuous protection.'
  }, {
    question: 'How Do I Request a Repair?',
    answer: 'Contact Opticore at 0800 055 4969 or 23tata0716@gmail.com. We typically schedule repair appointments within 24 to 48 hours.'
  }, {
    question: 'What Does "Unlimited Repairs" Mean?',
    answer: 'You may request unlimited repair visits and technician time for all essential appliances and systems covered under your Opticore plan (such as your washing machine, boiler, or drainage system). Please note: Appliances older than 10 years, accidental or liquid damage, and general wear and tear not caused by mechanical or electrical faults are excluded.'
  }, {
    question: 'Can I Cancel My Plan and Get a Refund?',
    answer: 'Yes. You can cancel within 14 days of purchase for a full refund, provided no repair work has started. Cancellations made between days 15 and 28 may be eligible for a partial refund, at our discretion, taking into account any services already rendered. No refunds are offered after 28 days. To cancel, email 23tata0716@gmail.com or call 0800 055 4969 with your order number. Refunds will be processed to your original payment method within 7 to 10 working days.'
  }, {
    question: 'What Appliances and Faults Are Covered?',
    answer: 'For Opticore plans: Included: Mechanical and electrical faults on registered appliances (e.g., breakdowns, faulty components for your washing machine, boiler, or drainage system). Excluded: Accidental or liquid damage, unregistered appliances, and appliances exceeding the age limit.'
  }];
  const [openIndex, setOpenIndex] = useState(null);
  const toggleFAQ = index => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="bg-gray-50 min-h-screen" data-id="element-263">
      <div className="bg-[#1a3a6c] text-white py-16" data-id="element-264">
        <div className="container mx-auto px-4 text-center" data-id="element-265">
          <h1 className="text-4xl font-bold mb-6" data-id="element-266">
            Frequently Asked Questions
          </h1>
          <p className="text-xl max-w-3xl mx-auto" data-id="element-267">
            Find answers to common questions about Opticore's appliance repair
            services and service plans.
          </p>
        </div>
      </div>
      <div className="container mx-auto px-4 py-16" data-id="element-268">
        <div className="max-w-3xl mx-auto" data-id="element-269">
          <div className="space-y-6" data-id="element-270">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-271">
                <button className="w-full text-left p-6 focus:outline-none flex justify-between items-center" onClick={() => toggleFAQ(index)} data-id="element-272">
                  <h3 className="text-lg font-semibold text-[#1a3a6c]" data-id="element-273">
                    {faq.question}
                  </h3>
                  {openIndex === index ? <ChevronUpIcon size={20} className="text-[#3b82f6]" data-id="element-274" /> : <ChevronDownIcon size={20} className="text-[#3b82f6]" data-id="element-275" />}
                </button>
                <div className={`px-6 pb-6 ${openIndex === index ? 'block' : 'hidden'}`} data-id="element-276">
                  <p className="text-gray-700" data-id="element-277">{faq.answer}</p>
                </div>
              </div>)}
          </div>
          <div className="mt-12 bg-[#f0f9ff] border border-[#e0f2fe] rounded-lg p-6" data-id="element-278">
            <h2 className="text-xl font-bold text-[#1a3a6c] mb-4" data-id="element-279">
              Still Have Questions?
            </h2>
            <p className="text-gray-700 mb-6" data-id="element-280">
              If you couldn't find the answer to your question, please don't
              hesitate to contact our customer support team.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-281">
              <a href="tel:08000554969" className="bg-[#3b82f6] text-white py-2 px-6 rounded-md font-medium hover:bg-[#1a3a6c] transition-colors text-center" data-id="element-282">
                Call 0800 055 4969
              </a>
              <a href="mailto:23tata0716@gmail.com" className="bg-white text-[#1a3a6c] py-2 px-6 rounded-md font-medium border border-[#1a3a6c] hover:bg-gray-50 transition-colors text-center" data-id="element-283">
                Email Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default FAQ;